import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from 'src/app/components/components.module';
import { SharedModule } from 'src/app/shared/shared.module';

import { SampleDetailsPageRoutingModule } from './sample-details-routing.module';
import { SampleDetailsPage } from './sample-details.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SampleDetailsPageRoutingModule,
    TranslateModule,
    SharedModule,
    ComponentsModule
  ],
  declarations: [SampleDetailsPage]
})
export class SampleDetailsPageModule {}
